module.exports = __webpack_public_path__ + "img/L9.1757498.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L9.png
// module id = 4l3i
// module chunks = 0